
import { useState } from 'react';

export default function WhatsAppButton() {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    window.open('https://api.whatsapp.com/send/?phone=56942334939&text=Deseo+Cotizar&type=phone_number&app_absent=0', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group relative w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 hover:from-green-500 hover:to-green-700 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 transform hover:scale-110 cursor-pointer"
        aria-label="Contactar por WhatsApp"
      >
        {/* Efecto de pulso */}
        <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-20"></span>
        
        {/* Icono de WhatsApp */}
        <i className="ri-whatsapp-line text-white text-3xl relative z-10"></i>
        
        {/* Tooltip */}
        {isHovered && (
          <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg whitespace-nowrap text-sm font-medium shadow-xl">
            ¿Necesitas cotizar?
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
              <div className="w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-gray-900"></div>
            </div>
          </div>
        )}
      </button>
    </div>
  );
}
